import React, { useEffect, useState } from "react";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import axios from "axios";
import styles from "./DetailsPage.module.css";
import aboutStyles from "../../about/About.module.css";
import { FaSpinner } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import moment from "moment";
import SocialMedias from "../../../shared/components/socialMedias/SocialMedias";
import { BaseURL, testUrl, universities } from "../BaseData";

const DetailsPage = () => {
    const { t, i18n } = useTranslation(); // Use the translation hook
    const { slug } = useParams();
    const navigate = useNavigate();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);

    // Find the current page index for active state
    const currentPageIndex = universities.findIndex(item => item.path === `/dropdown/${slug}`);


    useEffect(() => {
        setError(null);
        setLoading(true);
        const fetchDropdown = axios.get(
            testUrl + "/api/dropdowns/" + slug
        );
        const fetchDropdownsData = axios.get(
            testUrl + "/api/dropdowns/"
        );

        Promise.all([fetchDropdown, fetchDropdownsData])
            .then(([dropdownResponse, dropdownsResponce]) => {
                const responseData = dropdownResponse.data;
                const responseDropdowns = dropdownsResponce.data;
                console.log(responseDropdowns);
                if (responseData && responseDropdowns) {
                    setDetails(responseData);
                    setDropdowns(responseDropdowns);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [slug, i18n.language]);

    console.log(dropdowns);

    if (loading) {
        return (
            <div className={styles.center}>
                <FaSpinner className={styles.spinner} />
                <p>{t("loading")}</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.center}>
                <MdErrorOutline className={styles.errorIcon} />
                <p>{t("error")}</p>
            </div>
        );
    }

    // Retrieve language-specific fields
    const siteTitle = details[`site_title_${i18n.language}`];
    const siteDetails = details[`site_details_${i18n.language}`];

    // const mainNews = news.filter((item) => item.is_main).slice(0, 2);
    // const latestNews = news.filter((item) => !item.is_main).slice(0, 4);

    // const settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     arrows: false,
    //     fade: true,
    // };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.contentContainer}>
                <h1 className={styles.title}>
                    {siteTitle}
                </h1>

                {/* Display all 3 images if they exist */}
                <div className={styles.imagesContainer}>
                    {details.image1 && (
                        <div className={styles.imageWrapper}>
                            <img src={details.image1} alt={`${siteTitle} 1`} className={styles.image} />
                        </div>
                    )}
                    {details.image2 && (
                        <div className={styles.imageWrapper}>
                            <img src={details.image2} alt={`${siteTitle} 2`} className={styles.image} />
                        </div>
                    )}
                    {details.image3 && (
                        <div className={styles.imageWrapper}>
                            <img src={details.image3} alt={`${siteTitle} 3`} className={styles.image} />
                        </div>
                    )}
                </div>

                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(siteDetails, {
                            ADD_TAGS: ["iframe"],
                            ADD_ATTR: [
                                "allow",
                                "allowfullscreen",
                                "frameborder",
                                "scrolling",
                            ],
                        }),
                    }}
                />

            </div>

            <div className={aboutStyles.sidebar}>
                <h3>{t("university")}</h3>
                <ul>
                    {universities.map((item, index) => (
                        (index === currentPageIndex ? (
                            <li className={aboutStyles.active} onClick={() => navigate(item.path)}>
                                <span className={aboutStyles.icon}>
                                    ▶
                                </span>
                                {t(item.text)}
                            </li>
                        ) : (
                            <li onClick={() => navigate(item.path)}>
                                {t(item.text)}
                            </li>
                        ))
                    ))}
                </ul>
                {/* <div className={styles.section}>
                    <h3>{t("socialMedias")}</h3>
                    <SocialMedias/>
                </div> */}
            </div>
        </div>
    );
};

export default DetailsPage;
